<template>
  <v-card
    elevation="0"
    rounded="lg"
  >
    <v-tabs
      v-model="currentTab"
      hide-slider
      show-arrows
      :class="{
       'd-flex': center,
       'align-center': center,
       'justify-center': center
      }"
    >
      <v-tab
        v-for="(tab, i) in list"
        :key="i"
        class="ma-1"
        :class="{
          'compact-tabs': compact
        }"
        @click="clickOnTab(tab)"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  name: 'TabsUI',

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    selectedTab: {
      type: Number,
      default: 0,
    },
    compact: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    currentTab: {
      get() {
        return this.selectedTab
      },
      set(value) {
        this.$emit('update:selectedTab', value)
      },
    },
  },

  methods: {
    clickOnTab(item) {
      this.$emit('click', item)
    },
  },
}
</script>
